import React from 'react';
import style from './style.scss';

const TabSet: React.SFC<{}> = ({ children }) => <div className={style.tabSet}>{children}</div>;
TabSet.defaultProps = {
  children: {},
};

export default TabSet;
